export default "__VITE_ASSET__BO78Ogv2__"